import {
    PROJECT_CONTRACTOR_NEXT_ID, PROJECT_CONTRACTOR_NEXT_ID_ERROR, PROJECT_CONTRACTOR_NEXT_ID_SUCCESS,
    ProjectContractorActionTypes
} from "../../actions/projects/ProjectContractorActions";
import {
    errorFetchingRequestState,
    getInitialRequestState,
    RequestStateProp,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";


export interface ProjectContractorState extends RequestStateProp {
    nextId: number
}

const initialState = {
    nextId: 0,
    request: getInitialRequestState()
}

export function ProjectContractorReducer(
    state: ProjectContractorState = initialState,
    action: ProjectContractorActionTypes
) {
    switch( action.type ) {
        case PROJECT_CONTRACTOR_NEXT_ID:
            return {
                ...state,
                nextId: 0,
                request: startFetchingRequestState()
            };
        case PROJECT_CONTRACTOR_NEXT_ID_SUCCESS:
            return {
                ...state,
                nextId: action.payload,
                request: successFetchingRequestState()
            };
        case PROJECT_CONTRACTOR_NEXT_ID_ERROR:
            return {
                ...state,
                nextId: 0,
                request: errorFetchingRequestState( action.error )
            };
        default:
            return state;
    }
}